import { render, staticRenderFns } from "./ClaimListTable.vue?vue&type=template&id=26764b32&"
import script from "./ClaimListTable.vue?vue&type=script&lang=js&"
export * from "./ClaimListTable.vue?vue&type=script&lang=js&"
import style0 from "./ClaimListTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports